/***
 * Querys UnreadBubble - Requests, Notifications, etc.
 */
import Backbone from 'backbone';
import { reqQueryString, idQueryString } from './inboxConstants';

const UnreadBubble = Backbone.Model.extend({
    backend: 'gcapi',
    url: function() {
        return `/web-gateway/inbox/unreadBubble?${reqQueryString}&${idQueryString}`;
    },
    poll: function() {
        if (!this.fetching) {
            this.fetching = true;
            var that = this;
            this.fetch({
                success: function(collection) {
                    collection.fetching = false;
                },
                error: that.onPollingError
            });
        }
    },

    onPollingError: function(collection, response) {
        collection.fetching = false;
        collection.pollingEnabled = false;
        if (typeof console !== 'undefined' && typeof console.log !== 'undefined') {
            console.log(
                new Date().toString() + ' - ' + 'Error polling: ' + response.status + ' ' + response.statusText
            );
        }
    },

    isPollingEnabled: function() {
        return true;
    },

    parse: function(response) {
        this.set('unreadBubble', response.unreadBubble);
        if (response.unreadBubble) {
            this.trigger('hasUnread', this);
        }
    }
});

export default UnreadBubble;
